import { HotelMap } from '../components/hotels/hotel-map';

// Test data with coordinates
const testHotels = [
  {
    id: '1',
    name: 'Test Hotel 1',
    location: 'Miami Beach',
    coordinates: {
      latitude: 25.7617,
      longitude: -80.1918,
      address: '123 Ocean Drive, Miami Beach, FL'
    },
    price: { amount: 250, currency: 'USD' },
    starRating: 4,
    amenities: ['WiFi', 'Pool', 'Spa']
  },
  {
    id: '2',
    name: 'Test Hotel 2',
    location: 'Downtown Miami',
    coordinates: {
      latitude: 25.7700,
      longitude: -80.2000,
      address: '456 Biscayne Blvd, Miami, FL'
    },
    price: { amount: 180, currency: 'USD' },
    starRating: 3,
    amenities: ['WiFi', 'Gym']
  }
];

export default function TestMapSimplePage() {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Simple Map Test
        </h1>
        
        <div className="h-[600px] w-full">
          <HotelMap
            hotels={testHotels}
            onMarkerClick={(hotelId) => console.log('Clicked hotel:', hotelId)}
          />
        </div>
      </div>
    </div>
  );
}
